module.exports = __webpack_public_path__ + "static/media/banner_ColorGame-half.f276e4da.png";